/**
 * API client for the Operations → Life Catch-Ups page.
 *
 * Backend: oh_operations Django app, alfred-suffixed endpoints under
 * /api/v1/oh_operations/life_catch_up/. Every `apiEndpoints.X` reference lives
 * INSIDE a function body (TDZ-safety — mirrors checklist.js / centre.js).
 */
import { isEmpty } from 'lodash'

import { sentryLogger } from 'sentry'

import { apiEndpoints } from './common'

import { makeRequestUrl } from '../app/helpers'
import { get, post } from '../request'

const fetchLifeCatchUps = async ({ url, queries } = {}) => {
  // The API's `next` link comes back as http:// behind the load balancer; on
  // the https site the browser refuses it and the page showed nothing once a
  // centre passed 100 catch-ups.
  const requestUrl = !isEmpty(url)
    ? window.location.protocol === 'https:'
      ? url.replace(/^http:\/\//, 'https://')
      : url
    : makeRequestUrl(`${apiEndpoints.lifeCatchUps}/alfred`, queries)
  try {
    const response = await get(requestUrl)
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in fetching life catch-ups')
    throw error
  }
}

const createLifeCatchUp = async (payload) => {
  try {
    const response = await post(`${apiEndpoints.lifeCatchUps}/alfred`, payload)
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in creating life catch-up')
    throw error
  }
}

const fetchLifeCatchUpPeople = async ({ role, search } = {}) => {
  try {
    const response = await get(
      makeRequestUrl(`${apiEndpoints.lifeCatchUpPeople}/alfred`, {
        role,
        search
      })
    )
    return response.data
  } catch (error) {
    sentryLogger(error, 'error in fetching life catch-up people')
    throw error
  }
}

export { fetchLifeCatchUps, createLifeCatchUp, fetchLifeCatchUpPeople }
